import { useBackdropDismiss } from '@/lib/useBackdropDismiss'
import { useEffect, useRef, type ReactNode } from 'react'
import { closeDialog } from '@/lib/dialogMotion'
export default function AdminDialog({
  title,
  onClose,
  children,
  busy = false,
  wide = false,
  extraWide = false,
}: {
  title: string
  onClose: () => void
  children: ReactNode
  busy?: boolean
  wide?: boolean
  extraWide?: boolean
}) {
  const backdrop = useBackdropDismiss(busy)
  const ref = useRef<HTMLDialogElement>(null)
  useEffect(() => {
    ref.current?.showModal()
  }, [])
  return (
    <dialog
      {...backdrop}
      ref={ref}
      aria-label={title}
      onClose={onClose}
      onCancel={(e) => {
        e.preventDefault()
        if (!busy) void closeDialog(ref.current)
      }}
      className={'row-detail-dialog fixed m-auto max-h-[85dvh] w-[calc(100%-2rem)] overflow-hidden rounded-2xl border border-slate-200 bg-white p-0 shadow-xl backdrop:bg-slate-900/40 ' + (extraWide ? 'max-w-7xl' : wide ? 'max-w-5xl' : 'max-w-2xl')}
    >
      <div className="flex max-h-[85dvh] flex-col">
        <header className="flex shrink-0 items-center justify-between border-b px-6 py-4">
          <h2 className="text-lg font-semibold">{title}</h2>
          <button
            type="button"
            disabled={busy}
            onClick={() => void closeDialog(ref.current)}
            className="rounded-lg border px-3 py-1 text-sm"
          >
            关闭
          </button>
        </header>
        <div className="min-h-0 overflow-auto overscroll-contain p-6">
          {children}
        </div>
      </div>
    </dialog>
  )
}
